import { render, staticRenderFns } from "./HeaderDropdownAccnt.vue?vue&type=template&id=2087ecbb&scoped=true"
import script from "./HeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./HeaderDropdownAccnt.vue?vue&type=script&lang=js"
import style0 from "./HeaderDropdownAccnt.vue?vue&type=style&index=0&id=2087ecbb&prod&lang=scss&scoped=true"
import style1 from "./HeaderDropdownAccnt.vue?vue&type=style&index=1&id=2087ecbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2087ecbb",
  null
  
)

export default component.exports